module.exports = __webpack_public_path__ + "img/file.86a95dc0.svg";